import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLensInTextbox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m15.75 14.75-4.1875-4.1875c.90624-1.125 1.4375-2.5313 1.4375-4.0625 0-3.5625-2.9375-6.5-6.5-6.5-3.5937 0-6.5 2.9375-6.5 6.5 0 3.5937 2.9063 6.5 6.5 6.5 1.5 0 2.9063-.5 4.0313-1.4063l4.1875 4.1875c.12493.15627.3124.2188.5312.2188.18747 0 .37507-.06253.5-.2188.31253-.2812.31253-.75 0-1.0312zm-14.25-8.25c0-2.75 2.2187-5 5-5 2.75 0 5 2.25 5 5 0 2.7813-2.25 5-5 5-2.7813 0-5-2.2187-5-5z",
		fill: "currentColor",
		strokeWidth: 1.3333
	})]
});
const ForwardRef = forwardRef(SvgLensInTextbox);
export { ForwardRef as ReactComponent };
